module.exports = __webpack_public_path__ + "img/9788995411681.c0111187.jpg";